import { render, staticRenderFns } from "./TVSchedule.vue?vue&type=template&id=11211af8&"
import script from "./TVSchedule.vue?vue&type=script&lang=js&"
export * from "./TVSchedule.vue?vue&type=script&lang=js&"
import style0 from "./TVSchedule.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports